import React, { useEffect } from "react";

/**
 * A drawer that slides out of the left sidebar, over the map.
 * Render it inside .map-container (position: relative) so it sits flush
 * against the sidebar's right edge.
 */
export default function SlidePanel({ title, subtitle, onClose, wide = false, xl = false, actions, children }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <aside className={`slide-panel${wide ? " slide-panel-wide" : ""}${xl ? " slide-panel-xl" : ""}`} role="dialog" aria-label={title}>
      <header className="slide-panel-header">
        <div>
          <h2>{title}</h2>
          {subtitle && <p className="slide-panel-subtitle">{subtitle}</p>}
        </div>
        <div className="slide-panel-actions">
          {actions}
          <button className="slide-panel-close" onClick={onClose} aria-label="Close panel">×</button>
        </div>
      </header>
      <div className="slide-panel-body">{children}</div>
    </aside>
  );
}
